import React from "react"
import { notification } from "antd"
import moment from "moment"
import api from "src/api"

export function useManageItems(items, getItems, onSuccessEdit,onSuccessGeoUpdate, onSuccessEditTable) {
  const [editData, setEditData] = React.useState(null)
  const [editTableData, setEditTableData] = React.useState(null)
  const [editTablePointId, setEditTablePointId] = React.useState(null)

  function onEditItem(id) {
    const item = items.find((item) => item.id === id)
    const newItem = {
      ...item,
      image: item.image !== "null" ? item.image : null,
      timeForHurryUp: moment(item.timeForHurryUp, "HH:mm:ss"),
      timeForKitchenHurryUp: moment(item.timeForKitchenHurryUp, "HH:mm:ss"),
      timeForTable: moment(item.timeForTable, "HH:mm:ss"),
      timeForKitchenTableTime: moment(item.timeForKitchenTableTime, "HH:mm:ss"),
      defaultTimeForHurryUp: moment(item.defaultTimeForHurryUp, "HH:mm:ss"),
      defaultTimeForKitchenHurryUp: moment(item.defaultTimeForKitchenHurryUp, "HH:mm:ss"),
      defaultTimeForTableTime: moment(item.defaultTimeForTableTime, "HH:mm:ss"),
      defaultTimeForKitchenTableTime: moment(item.defaultTimeForKitchenTableTime, "HH:mm:ss"),
      timeStartForDelivery: moment(item.timeStartForDelivery, "HH:mm:ss"),
      timeEndForDelivery: moment(item.timeEndForDelivery, "HH:mm:ss"),
      stepTimeDelivery: moment(item.stepTimeDelivery, "HH:mm:ss"),
      preorderIntervals: item.preorderIntervals.map((item) => ({
        start: moment(item.start, "HH:mm:ss"),
        end: moment(item.end, "HH:mm:ss"),
      })),
      schedule: item.schedule.map((item) => ({
        ...item,
        startTime: moment(item.startTime, "HH:mm"),
        endTime: moment(item.endTime, "HH:mm"),
        lunchTimeStart: item.lunchTimeStart
          ? moment(item.lunchTimeStart, "HH:mm")
          : null,
        lunchTimeEnd: item.lunchTimeEnd ? moment(item.lunchTimeEnd, "HH:mm") : null,
      })),
    }
    setEditData(newItem)
    onSuccessEdit()
  }

  async function onSaveEdit(values) {
    try {
      await api.put(`points/${editData.id}`, values)

      notification.success({ message: "Точка изменена" })

      onSuccessEdit()
      setEditData(false)
    } catch (error) {
      console.log("Ошибка изменения", error)
      notification.error({ message: "Ошибка изменения" })
      throw error
    } finally {
      getItems()
    }
  }

  async function onUpdateGeo(values) {
    try {
      await api.post("delivery-area/geo-update", values)

      notification.success({ message: "Данные обновлены" })

      onSuccessGeoUpdate()
      setEditData(false)
    } catch (error) {
      console.log("Ошибка обновления", error)
      notification.error({ message: "Ошибка обновления" })
      throw error
    } finally {
      getItems()
    }
  }

  async function onEditTableData(id) {
    try {
      const { data } = await api.get(`points/tables/${id}`)
      const newData = {
        elements: data.elements.sort((a, b) => a.number > b.number)
      }
      setEditTableData(newData)
      setEditTablePointId(id)
      onSuccessEditTable()
    } catch (error) {
      console.log("Ошибка подгрузки столиков")
    }
  }

  async function onSaveEditTable(data) {
    try {
      await api.post(`points/tables`, data)
      setEditTableData(null)
      setEditTablePointId(null)
      onSuccessEditTable()
    } catch (error) {
      notification.error({ message: "Ошибка обновления " })
    }
  }

  async function onSendMass(values) {
    try {
      await api.post('points/mass-edit-time', values, {useV2Api: true})


      notification.success({message: "Время изменено"})
      getItems()
    } catch (error) {
      console.log("Ошибка изменения", error)
      notification.error({ message: "Ошибка изменения" })
      throw error
    }
  }

  async function fetchPointById(pointId) {
    try {
      const {data} = await api.get(`points/${pointId}`)
      return data?.point ?? null
    } catch {
      return null
    }
  }

  return { editData, editTableData, editTablePointId, onSaveEdit, onEditItem, onUpdateGeo, onEditTableData, onSaveEditTable, onSendMass, fetchPointById }
}
